import { all, fork } from 'redux-saga/effects';
import { listImagesSaga } from './list-images';
export function* rootSaga() {
    yield all([fork(listImagesSaga)]);
}
